<template>
  <v-breadcrumbs class="breadcrumbs py-5" :items="breadcrumbs" divider="/" />
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Breadcrumbs',
  props: {
    items: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  computed: {
    breadcrumbs() {
      const regionURL = `/${this.region.id}-${this.region.name}`
      const breadcrumbs = [{ title: this.region.name, disabled: false, href: regionURL }]
      return breadcrumbs.concat(...this.items)
    },
    ...mapGetters({
      region: 'region/region',
    }),
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.breadcrumbs {
  padding: 0;
  @include xs {
    padding-left: 20px;
  }
}
</style>
<style lang="scss">
.breadcrumbs {
  li {
    font-size: 17px;
  }
  a {
    color: $black50 !important;
  }
}
</style>
